import { AloActivity } from './AloActivity'
import { AloAddress, cleanAloAddress, getDefaultAloAddress } from './AloAddress'
import { AloBase, getDefaultAloBase } from './AloBase'
import { AloCommande, cleanAloCommande } from './AloCommande'
import { AloUser, cleanAloUser } from './AloUser'


export interface AloFamily extends AloBase {     
    actId:number
    address:AloAddress
    membres: Array<AloUser>
    commandes: Array<AloCommande>
}

export const getDefaultAloFamily = ():AloFamily => {
    return {  
        ...getDefaultAloBase(),
        actId:0,  
        address:getDefaultAloAddress(),        
        membres:[],
        commandes:[]
    }
}

export const cleanAloFamily = (family:AloFamily) => {
    if(!family) return    
    if(!family.id) delete family.id
    if(!family.actId) delete family.actId
    cleanAloAddress(family.address)
    if(!family.address.ctyId) delete family.address
    family.membres.forEach(m => cleanAloUser(m))
    family.commandes.forEach(c => cleanAloCommande(c))
}